<template>
	<section>
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="filters">
						<el-form-item>
							<el-input v-model="filters.email" placeholder="Email" clearable>
								<el-button slot="append" icon="el-icon-search" @click="getInvitations"></el-button>
							</el-input>
						</el-form-item>
					</el-form>
				</el-col>

				<!--列表-->
				<el-table stripe :data="invitations" highlight-current-row v-loading="firstLoading" style="width: 100%;">
					<el-table-column prop="user_name" label="Company" >
					</el-table-column>
					<el-table-column prop="email" label="Email"  >
					</el-table-column>
					<el-table-column prop="createDate" label="Date Time"  :formatter="formatTimesTamp">
					</el-table-column>
					<el-table-column prop="status" label="Status" :formatter="formatInvitationStatus">
					</el-table-column>
					<el-table-column label="Action">
						<template slot-scope="scope" v-if="scope.row.status===0">
							<el-button size="small" @click="editInvitationStatus(scope.row.invitationNo,1)">Approve</el-button>
							<el-button size="small" @click="editInvitationStatus(scope.row.invitationNo,2)">Reject</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="prev, pager, next" @current-change="handleInvitationPageChange" :page-size="pageSize" :total="invitationTotalPage" style="float:right;">
					</el-pagination>
				</el-col>

	</section>
</template>


<script>
	import util from '../../common/js/util'
	import { getDoctorMembers,getInvitations,invitationRegister,editInvitationStatus } from '../../api/memberService';
	import {defaultPageSize} from "../../globalVar";

	export default {
		data() {
			return {
				firstLoading: false,
				secondLoading: false,
				thirdLoading: false,
				pageSize:defaultPageSize,

				activeName:"first",

				filters: {
					email: ''
				},

				members: [],

				groups:[],
				invitations:[],

				total:0,

				invitationFilter:"",
				invitationTotalPage: 0,
				invitationPage: 1,

				membersFilter:"",
				membersTotalPage: 0,
				membersPage: 1,

				sels: [],//列表选中列
				editMemberObj:{},
				editMemberVisible: false,//编辑界面是否显示
				addGroupVisible:false,
				invitationVisible:false,

				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				invitationRules: {
					role: [
						{ required: true, message: 'Role is required.', trigger: 'blur' }
					],
					email:[
						{ required: true, message: 'email is required.', trigger: 'blur' },
						{ validator: util.validateEmail, trigger: 'blur' }
					]
				},
				//新增界面数据
				member: {
					id:"",
					userName:"",
					email:"",
					phone:"",
					status:"",
					pendingTransaction:7,
					pendingAmount:"",
					alias:""
				},
				group:{
					id:'',
					groupName:"",
					users:[],
					pendingTransaction:7,
					pendingAmount:""
				},
				invitation:{
					id:"",
					email:"",
					status:"",
					dateTime:"",
					role:""
				}

			}
		},
		methods: {
			formatInvitationStatus(row, column){
				if(row.status===0){
					return "Pending";
				}else if(row.status===1){
					return "Approve";
				}else {
					return "Reject"
				}
			},
			formatTimesTamp(row, column){
				return util.formatDate.format(new Date(row.createDate),'yyyy-MM-dd hh:mm:ss');
			},
			handleInvitationPageChange(val) {
				this.invitationPage = val;
				this.getInvitations();
			},
			editInvitationStatus(id,status){
                this.$confirm("Are you sure?","Warning",{
                    type:"warning"
                }).then(()=>{
                    editInvitationStatus({invitationNo:id,status:status}).then((res)=>{
                        if(res.status===200){
                            this.$message({
                                message:res.message,
                                type:"success"
                            });
                            this.getInvitations();
                        }else{
                            this.$message({
                                message:res.message,
                                type:"error"
                            })
                        }
                    })
				}).catch(()=>{

                })

			},
			getInvitations(){
				let para = {
					current: this.invitationPage,
					size:this.pageSize,
					condition:this.filters.email
				};

				this.firstLoading = true;
				getInvitations(para).then(res=>{
					this.firstLoading = false;
					if(res.status===200){
						this.invitations = res.result.records;
						this.invitationTotalPage = res.result.total;
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						})
					}
				})
			},
			invitationRegister(param){
				this.$refs.invitation.validate((valid) => {
					if (valid) {
						invitationRegister({roleId:this.invitation.role,email:this.invitation.email}).then(res=>{
							if(res.status===200){
								this.$message({
									message: 'Success',
									type: 'success'
								});
								this.invitationVisible = false;
								this.getInvitations();
							}else{
								this.$message({
									message: res.message,
									type: 'error'
								});
							}
						}).catch(error => console.log(error))
					}
				});
			}
		},
		mounted() {
			this.getInvitations();
		}
	}

</script>


// WEBPACK FOOTER //
// invitations.vue?4771e5f0